<template>
  <div>
    <SingleSectionSelector
      :permitted-sections="permittedSections"
      @selected="setCategoryFilter"
    />
    <a-table
      ref="product-table"
      :columns="columns"
      :data-source="productsData"
      :pagination="pagination"
      class="product-table"
      :row-key="(record) => record.id"
      :loading="loading"
      @change="handleTableChange"
    >
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        class="custom-filter-dropdown"
        style="padding: 8px"
      >
        <a-input
          :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="confirm"
        />
        <a-button
          type="primary"
          size="small"
          style="width: 90px; margin-right: 8px"
          @click="confirm"
        >
          {{ $t('common.search') }}
        </a-button>
        <a-button
          size="small"
          style="width: 90px"
          @click="clearFilters"
        >
          {{ $t('common.reset') }}
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />
      <template
        slot="checkbox"
        slot-scope="text, record"
      >
        <a-checkbox
          :checked="selectedProducts.some(product => product.offerHashId === record.id)"
          :disabled="checkboxDisabled(record)"
          @change="() => handleSectionCheckbox(record)"
        />
      </template>
      <template
        slot="images"
        slot-scope="text, record"
      >
        <MainImageView
          :images="record.variation ? record.variation.images : []"
          type="icon"
        />
      </template>
      <template
        slot="title"
        slot-scope="text, record"
      >
        <div v-if="record && record.variation">
          <span>{{ $l(record.variation.title) }}</span>
        </div>
      </template>
      <template
        slot="code"
        slot-scope="text"
      >
        {{ text }}}}
      </template>
      <template
        slot="price"
        slot-scope="text"
      >
        <span>{{ text | currency }}</span>
        <small>UZS</small>
      </template>
    </a-table>
  </div>
</template>
<script>
import SingleSectionSelector from '@/components/common/SingleSectionSelector'
import MainImageView from '@/components/common/MainImageView'

import productService from '@/services/api/manager/product-service'

export default {
  name: 'SelectProducts',
  components: {
    SingleSectionSelector,
    MainImageView,
  },
  props: {
    permittedSections: {
      type: Array,
      default: () => [],
    },
    promotions: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      filter: {
        title: '',
        code: '',
        status: null,
        active: true,
      },
      sorting: null,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 25,
      },
      productsData: [],
      loading: false,
      selectedProducts: [],
      freeSlots: [],
      columns: [
        {
          title: '',
          scopedSlots: {
            customRender: 'checkbox',
          },
        },
        {
          title: '',
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' },
        },
        {
          title: this.$t('product.title'),
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: this.$t('product.code'),
          dataIndex: 'code',
          sorter: true,
          scopedSlots: { customRender: 'code', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' },
        },
        {
          title: this.$t('product.price'),
          dataIndex: 'price',
          sorter: true,
          scopedSlots: { customRender: 'price' },
        },
      ],
    }
  },

  watch: {
    promotions: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.freeSlots = [...newVal.freeSlots]
      },
    },

  },

  mounted() {
    this.setCategoryFilter()
  },

  methods: {
    checkboxDisabled(record) {
      return (this.promotions.promotionPlaces.some(place => place.product_id === record.productHash) ||
              this.selectedProducts.some(place => place.product_id === record.productHash && place.offerHashId !== record.id) ||
              (this.freeSlots.length === 0 && !this.selectedProducts.some(product => product.offerHashId === record.id)))
    },

    setCategoryFilter (cat, sub, sec) {
      this.filter.category_id = cat ?? null
      this.filter.sub_category_id = sub ?? null
      this.filter.section_id = sec ?? this.permittedSections.join(',')
      this.fetchProducts()
    },

    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      else
        this.sorting = null

      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length === 1)
          this.filter[key] = filter[key][0]
        else
          this.filter[key] = null
      })

      this.pagination.current = pagination.current

      this.fetchProducts()
    },

    fetchProducts () {
      this.loading = true
      productService.getProducts(this.pagination, this.filter, this.sorting)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.productsData = response.data.content
            this.pagination.total = response.data.pagination.total
          }
          this.loading = false
        })
    },

    handleSectionCheckbox(row) {
      const index = this.selectedProducts.findIndex(product => {
        return product.offerHashId === row.id
      })

      if (index < 0) {
        const freeSlot = this.freeSlots.pop()
        this.selectedProducts.push({
          offerHashId: row.id,
          variationHashId: row.variation.id,
          product_id: row.productHash,
          placeHashId: freeSlot.hash_id,
          sectionId: null,
        })
        this.$emit('change', this.selectedProducts)
      } else {
        const slot = this.selectedProducts.splice(index, 1)
        this.freeSlots.push({
          ...slot,
          offerHashId: null,
          variationHashId: null,
          product_id: null,
          sectionId: null,
        })
      }
    },
  },
}
</script>
